// Note: The first file of a module here, must also register the module

import "./custom-field-form.component";
import "./custom-field-attachment-list-item.component";
import "./custom-field-attachment-chips.component";
import "./view-custom-field-attachment.component";
import "./view-multiple-custom-field-attachments.component";
